var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOther = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#737373",
  d: "M15 12c0 1.655-1.345 3-3 3s-3-1.345-3-3 1.345-3 3-3 3 1.345 3 3m9 0c0 1.655-1.345 3-3 3s-3-1.345-3-3 1.345-3 3-3 3 1.345 3 3M6 12c0 1.655-1.345 3-3 3s-3-1.345-3-3 1.345-3 3-3 3 1.345 3 3"
})));
export default SvgIconOther;